import moment from "moment";
import { user } from "../../../user/user";
import { SubscriptionType } from "../../../types/billing/SubscriptionType";

export function useEvalSubscription() {
    const currentUser = user.current();
    if (!currentUser) return {
        isTrial: false,
        isTrialEnded: false,
        trialPeriodDays: 0,
        subscriptionRemainingDays: 0,
        isSubscriptionEnded: false
    }

    const today = moment.utc().startOf('day');

    const isTrial = currentUser.evalTrialPeriodEnd != null;
    const isSubscriptionEnded = !isTrial && currentUser.evalSubscriptionExpiration == null && currentUser.evalSubscriptionPrev === SubscriptionType.pro;
    const subscriptionRemainingDays = isTrial || isSubscriptionEnded || currentUser.evalSubscriptionExpiration == null
        ? 0 : moment.utc(currentUser.evalSubscriptionExpiration).diff(today, 'day') + 1;
    const isTrialEnded = !isTrial && !subscriptionRemainingDays && currentUser.evalSubscriptionPrev === SubscriptionType.trial;
    const trialPeriodDays = isTrial && !isTrialEnded
        ? moment.utc(currentUser.evalTrialPeriodEnd).diff(today, 'days') + 1 : 0;

    return {
        isTrial,
        isTrialEnded,
        trialPeriodDays,
        isSubscriptionEnded,
        subscriptionRemainingDays
    }
}